// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 640px;
}

mat-card-content p {
  margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/apps/app-notifications/app-notifications.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAGE;EACE,mBAAA;AAAJ","sourcesContent":[".container {\n  max-width: 640px;\n}\n\nmat-card-content {\n  p {\n    margin-bottom: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
